import { useNavigate } from 'react-router';
import { FileQuestion } from 'lucide-react';
import { useDarkMode } from '../context/DarkModeContext';

export default function NotFound() {
  const { darkMode } = useDarkMode();
  const navigate = useNavigate();
  const muted = darkMode ? 'text-slate-400' : 'text-slate-500';

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <FileQuestion className={`w-12 h-12 mx-auto mb-4 ${muted}`} />
        <h1 className="text-xl font-semibold mb-2">Seite nicht gefunden</h1>
        <p className={`text-sm mb-6 ${muted}`}>
          Diese Adresse gibt es nicht (mehr). Prüfe den Link oder geh zurück zum Dashboard.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
        >
          Zum Dashboard
        </button>
      </div>
    </div>
  );
}
